<template>
    <div>
        <div class="row">
            <div class="col-md-8 offset-md-2 corner-radius" style="background-color: #fff; padding-bottom: 30px;">
                <div class="row">
                    <div class="col-md-10 offset-md-1 titulo-site center padding_categoria">
                        <b class="vermelho_escuro">Não Corra o Risco de Ficar Sem a Proteção do Quadro do Padre Pio!</b>
                    </div>
                </div>
                <!-- --------- -->
                <div class="row padding_categoria">
                    <div class="col-md-3 offset-md-1 font-texto center-mobile">
                        <img :src="require('@/assets/images/estampa_pepio.jpg')" width="100%;" class="img-mobile">
                    </div>
                    <div class="col-md-7 font-texto">
                        <p>
                            Você sabia que ter um quadro com a foto do Padre Pio, abençoado por um sacerdote, em sua
                            casa, pode <b>transformar radicalmente o ambiente onde você vive?</b>
                        </p>
                        <p>
                            Mais do que um símbolo de devoção, esta Estampa é uma poderosa fonte de proteção espiritual
                            para você e para todos que vivem sob o mesmo teto.
                        </p>
                        <p>
                            <a type="button" href="#receba" @click.prevent="scrollToForm"
                                class="w-100 btn btn-lg btn-success">EU QUERO</a>
                        </p>
                    </div>
                </div>
                <!-- --------- -->
                <div class="row">
                    <div class="col-md-10 offset-md-1 titulo-dispositivo center padding_categoria">
                        <b>Por que ter o quadro do Padre Pio na sua casa?</b>
                    </div>
                </div>
                <!-- --------- -->
                <div class="row padding_categoria">
                    <div class="col-md-10 offset-md-1">
                        <div class="card">
                            <img :src="require('@/assets/images/imagem1.jpg')" class="card-img-top">
                            <div class="card-body">
                                <h5 class="card-title"><b>Poder Exorcístico:</b></h5>
                                <p class="card-text font-texto">Padre Pio foi conhecido por sua luta incansável contra o
                                    mal. Sua presença espiritual, representada nesta estampa abençoada, é um poderoso
                                    escudo contra influências malignas e tentações que possam afetar você e sua família.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- --------- -->
                <div class="row padding_categoria">
                    <div class="col-md-10 offset-md-1">
                        <div class="card">
                            <img :src="require('@/assets/images/imagem2.jpg')" class="card-img-top">
                            <div class="card-body">
                                <h5 class="card-title"><b>Graças e Bênçãos:</b></h5>
                                <p class="card-text font-texto">Ao colocar esta estampa em um local de destaque, você
                                    <b>abre as portas do seu lar</b> para receber graças especiais pela intercessão de
                                    São Pio de Pietrelcina. Seu lar será um lugar de paz, proteção e bênçãos contínuas
                                    <b>derramadas sobre todos os que ali residem.</b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- --------- -->
                <div class="row padding_categoria">
                    <div class="col-md-10 offset-md-1">
                        <div class="card">
                            <img :src="require('@/assets/images/imagem3.jpg')" class="card-img-top">
                            <div class="card-body">
                                <h5 class="card-title"><b>União Familiar:</b></h5>
                                <p class="card-text font-texto">Um lar onde reina a proteção espiritual do Padre Pio é
                                    um lar mais unido. <b>Sua presença inspira oração, fé e reconciliação.</b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- --------- -->
                <div class="row padding_categoria">
                    <div class="col-md-12 background_vermelho branco center padding_titulo">
                        <div class="row">
                            <div class="col-md-10 offset-md-1 font-texto">
                                <p>
                                    <b><span class="titulo-vermelho titulo-dispositivo">O risco de <span
                                                class="amarelo">NÃO</span> tê-lo</span></b>
                                </p>
                                <p>
                                    Sem um escudo espiritual poderoso como este, <b>sua casa pode ficar vulnerável</b>
                                    às tribulações que o mundo nos impõe. <b>Não permita que seu lar fique
                                        desprotegido</b> diante das investidas do maligno.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- --------- -->
                <div class="row">
                    <div class="col-md-10 offset-md-1 titulo-dispositivo center padding_categoria">
                        <b>Por que distribuímos esta Estampa <span class="verde">gratuitamente</span>?</b>
                    </div>
                </div>
                <!-- --------- -->
                <div class="row padding_categoria">
                    <div class="col-md-4 offset-md-1 font-texto center-mobile">
                        <img :src="require('@/assets/images/estampa_pepio.jpg')" width="100%;" class="img-mobile">
                    </div>
                    <div class="col-md-6 font-texto">
                        <p>
                            A missão da Associação Regina Fidei é levar a proteção e a intercessão do Padre Pio ao maior
                            número de lares possível, especialmente em tempos tão desafiadores.
                        </p>
                        <p>
                            <b>Esta Estampa, <span class="sublinhado">já abençoada por um sacerdote</span>, é oferecida
                                gratuitamente porque acreditamos que todos, independentemente de condições financeiras,
                                precisam ter em suas casas a presença espiritual de São Pio de Pietrelcina, um dos
                                maiores santos da Igreja.</b>
                        </p>
                        <p style="padding-right: 12%;">
                            É uma forma de espalhar a fé, fortalecer as famílias e inspirar a oração em cada canto do
                            Brasil.

                        </p>
                    </div>
                </div>
                <!-- --------- -->
                <div class="row">
                    <div class="col-md-10 offset-md-1 titulo-dispositivo center padding_categoria">
                        <b>Como receber a sua?</b>
                    </div>
                </div>

                <!-- --------- -->
                <div class="row padding_categoria">
                    <div class="col-md-10 offset-md-1 font-texto">

                        <p>
                            <b>A única coisa que pedimos é o preenchimento de <a href="#receba"
                                    @click.prevent="scrollToForm">um formulário
                                    simples</a>, para que possamos lhe enviar a estampa pelo correio diretamente para
                                sua casa.</b>
                        </p>
                        <p>
                            É muito rápido:
                        </p>
                        <p style="padding-left: 7%;">
                            1. Preencha o <a href="#receba" @click.prevent="scrollToForm">formulário abaixo</a> com seus
                            dados.
                        </p>
                        <p style="padding-left: 7%; padding-right: 10%;">
                            2. <b>Confira atentamente para evitar extravios, pois esta Estampa já foi abençoada.</b>
                        </p>
                        <p style="padding-left: 7%;">
                            3. Pronto. Aguarde para receber esta foto especial (tamanho 21cm x 29,7cm) pelo correio,
                            diretamente no conforto do seu lar.
                        </p>
                        <p>
                            <a href="#receba" class="w-100 btn btn-lg btn-success" @click.prevent="scrollToForm">EU
                                QUERO MINHA ESTAMPA BENTA</a>
                        </p>
                        <p>
                            Imagine o impacto de ver a fisionomia do Padre Pio em um lugar de destaque na sua sala ou
                            quarto. Imagine o alívio ao saber que <b>sua casa está protegida por uma bênção
                                especial.</b>
                        </p>
                        <p>
                            Não perca esta oportunidade de transformar espiritualmente seu lar!
                        </p>
                        <p>
                            <b>Preencha agora mesmo o <a href="#receba" @click.prevent="scrollToForm">formulário
                                    abaixo</a> e peça a Estampa abençoada
                                do Padre Pio!</b>
                        </p>
                        <p>
                            Que a presença do Santo de Padre Pio seja a luz que ilumine sua família!
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>

const scrollToForm = () => {
    const element = document.getElementById("receba");
    if (element) {
        element.scrollIntoView({ behavior: "smooth" });
    }
}

</script>